import { RuleProps } from 'types/application';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const LICENCE_TYPE = 'licence-type';
export const ISP_DETAILS = 'isp-details';
export const TARGET_MARKET_USERS = 'target-market-users';


export const ISP_LICENCE = [
    {
        sectionID: LICENCE_TYPE,
        sectionName: 'Licence Type',
        fieldList: [
            {
                id: 'start-date',
                label: 'Start Date',
                type: 'text'
            },
            {
                id: 'end-date',
                label: 'End Date',
                type: 'text'
            },
            {
                id: 'do-you-have-sbo-fbo',
                label: 'Do you have a SBO or FBO Licence from IMDA?',
                type: 'text'
            },
            {
                id: 'licence-type',
                label: 'Licence Type',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ISP_DETAILS,
        sectionName: 'Internet Service Details',
        fieldList: [
            {
                id: 'type-of-services',
                label: 'Type Of Services',
                type: 'text'
            },
            {
                id: 'others',
                label: 'If Others Services Please Specify',
                type: 'text'
            }
        ]
    },
    {
        sectionID: TARGET_MARKET_USERS,
        sectionName: 'Target Market/Users',
        fieldList: [
            {
                id: 'target-type',
                label: '',
                type: 'text',
                span: 12,
            },
            {
                id: 'others',
                label: 'If Others Target Market/Users, Please Specify',
                type: 'text',
                span: 12,
            },
            {
                id: 'service-start-date',
                label: 'Service Start Date',
                type: 'text'
            },
            {
                id: 'we-own-internet-access-points',
                label: 'We own Internet Access points',
                type: 'text'
            },
            {
                id: 'name-of-provider',
                label: 'Name of Provider',
                type: 'text'
            },
            
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
